import { TEMPLATE_WEBMCP_LOG_PREFIX } from './constants';
import { sanitizeLogValue } from './sanitize';

export type TemplateWebMCPLogEvent =
  | 'register'
  | 'unregister'
  | 'invocation_start'
  | 'invocation_complete'
  | 'relay_rejected';

export type TemplateWebMCPLogDetails = {
  tool?: string;
  invocationId?: string;
  outcome?: 'success' | 'validation_failure' | 'cancellation' | 'unexpected_failure';
  durationMs?: number;
  input?: unknown;
  output?: unknown;
  [key: string]: unknown;
};

export function createInvocationId(): string {
  return `webmcp-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

export function logTemplateWebMCP(
  event: TemplateWebMCPLogEvent,
  details: TemplateWebMCPLogDetails = {},
): void {
  console.info(TEMPLATE_WEBMCP_LOG_PREFIX, event, sanitizeLogValue(details));
}
